import { getUsersMeOrganisationsCurrentTasksPropertiesSelector } from "../../taskAvailablePropertiesSelector";
import { RootState } from "../../../../../store";

export const taskAvailablePropertiesLoadingSelector = (state: RootState) => {
  return getUsersMeOrganisationsCurrentTasksPropertiesSelector(state)
    ?.isLoading;
};
